(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sportinfo/match-info-components/assets/javascripts/over-under.js') >= 0) return;  svs.modules.push('/components/sportinfo/match-info-components/assets/javascripts/over-under.js');
"use strict";


const {
  useSelector
} = ReactRedux;
const {
  selectEventStatisticCurrentValueByType
} = svs.components.sportinfo.matchInfoRedux.selectors;
const {
  ProductOddsCell,
  ProductOddsRow,
  ProductOddsTable
} = svs.components.sportinfo.matchInfoComponents;
const {
  EventTypeId,
  EventTypeField
} = svs.components.sportinfo.common.constants;
const {
  createEventStatisticsKey
} = svs.components.sportinfo.common.helpers;
const {
  getOutcomeLabelsForEventType,
  getOutcomeCount
} = svs.components.sport.tipsenShared;
const {
  SportTypes
} = svs.components.sport.sportTypes;
const {
  Odds: formatOdds
} = svs.utils.format;
const OverUnder = _ref => {
  var _odds;
  let {
    betEvent,
    matchId,
    branding
  } = _ref;
  const eventTypeId = EventTypeId.OVER_UNDER;
  const sportType = SportTypes.Soccer;
  const eventStatisticsKey = createEventStatisticsKey({
    matchId,
    eventTypeId,
    periodNumber: betEvent.periodNumber,
    eventNumber: betEvent.eventNumber
  });
  let odds = useSelector(state => selectEventStatisticCurrentValueByType(state, eventStatisticsKey, EventTypeField.Odds));
  if (odds.length === 0) {
    odds = new Array(getOutcomeCount(EventTypeId.OVER_UNDER)).fill(null);
  }
  const outcomeLabels = getOutcomeLabelsForEventType(eventTypeId, sportType);
  return React.createElement(ProductOddsTable, {
    branding: branding,
    className: "match-info-over-under-odds"
  }, React.createElement(ProductOddsRow, {
    branding: branding,
    className: "match-info-over-under-odds-row"
  }, React.createElement(ProductOddsCell, {
    content: React.createElement("div", {
      className: "product-odds-label"
    }, React.createElement("div", {
      className: "product-odds-rowheading"
    }, "Totalt antal m\xE5l")),
    rowHeading: true
  }), outcomeLabels === null || outcomeLabels === void 0 ? void 0 : outcomeLabels.map(labels => React.createElement(ProductOddsCell, {
    className: "product-odds-cell-heading",
    columnHeading: true,
    content: labels.text,
    key: labels.text
  }))), odds.length > 0 && React.createElement(ProductOddsRow, {
    branding: branding,
    className: "match-info-over-under-odds-row"
  }, React.createElement(ProductOddsCell, {
    content: React.createElement("div", {
      className: "product-odds-label"
    }, React.createElement("div", {
      className: "product-odds-rowheading"
    }, "\xD6ver/Under 2,5 m\xE5l")),
    rowHeading: true
  }), (_odds = odds) === null || _odds === void 0 ? void 0 : _odds.map((odd, i) => React.createElement(ProductOddsCell, {
    content: formatOdds(odd) || '-',
    key: i
  }))));
};
setGlobal('svs.components.sportinfo.matchInfoComponents.OverUnder', OverUnder);

 })(window);